import Link from "next/link";
import * as ga from '/lib/ga'


const BundleOptionsList = ({ product, currency, categoryUrlSuffix, websiteurl, session, websiteID, eventCommonObj, styles }) => {
    return (
        <div className={styles.bundle_product_list}>
              <h2>Includes:</h2>
              <ul>
                {product?.items[0]?.options?.map((item, index) => (
                  <li key={index}>
                    <Link
                      prefetch={false}
                      href={{
                        pathname: "/_url-resolver",
                        query: {
                          pathname: `${item?.product?.url_key}${categoryUrlSuffix}`,
                          type: "PRODUCT",
                          url_path: item?.product?.url_key,
                          url_key: item?.product?.url_key,
                          cat_id: item?.product?.id,
                        },
                      }}
                      as={`${websiteurl}${item?.product?.url_key}${categoryUrlSuffix}`}
                      onClick={() => {
                        ga.ProductClicks(product, session, websiteID.toFixed(), item?.product?.name, eventCommonObj)
                      }}>
                      {item?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
    )
}

export default BundleOptionsList;